// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-loading-loading-page-loading-bhrop{height:100%;width:100%;align-items:center;background:hsla(0,0%,100%,.8);display:flex;justify-content:center;left:0;position:fixed;top:0;z-index:1030}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": "components-loading-loading-page-loading-bhrop"
};
module.exports = ___CSS_LOADER_EXPORT___;
